import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../Icon";

export const ButtonDropdown = ({type, svg, text, actions, size, full, loading, style, disabled}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    let className = `button-dropdown ${type ? type : 'primary'}`;
    className += size ? ` ${size}` : ' regular';

    if(svg){
        className += ' has-svg';
    }

    if(full){
        className += ' full';
    }

    if(isOpen){
        className += ' open';
    }

    // Fechar dropdown quando clicar fora
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleButtonClick = () => {
        if(loading || disabled) return;
        setIsOpen(!isOpen);
    };

    const handleActionClick = (action) => {
        if(!action.link){
            action.action();
            setIsOpen(false);
            return;
        }

        if (action.newTab) {
            window.open(action.link);
        } else {
            navigate(action.link);
        }
        setIsOpen(false);
    };

    return (
        <div className="button-dropdown-container" ref={dropdownRef}>
            <button 
                className={className} 
                style={style ?? null} 
                onClick={handleButtonClick} 
                disabled={loading === true || disabled === true}
            >
                {svg && !loading && (
                    <Icon name={svg} size={size === 'small' ? 14 : 16} strokeWidth={2.25} className="dropdown-leading-icon" />
                )}
                {loading ? 'Carregando...' : text}
                <Icon name="arrow-dropdown" size={16} className={`dropdown-arrow ${isOpen ? 'open' : ''}`} />
            </button>
            
            {isOpen && (
                <div className="dropdown-menu">
                    {actions.map((action, index) => (
                        <button
                            key={index}
                            className="dropdown-item"
                            onClick={() => handleActionClick(action)}
                            disabled={action.disabled}
                        >
                            {action.svg && (
                                <Icon name={action.svg} size={16} />
                            )}
                            {action.text}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

export default ButtonDropdown;